// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fLEO","index":"styles_index__5_blc"};